import styled from '@emotion/styled';
import tw from 'twin.macro';

export const Nudge = styled.span`
  font-size: 0.6rem;
  ${tw`ml-1 text-red-400`}
`;
